export const setParams = (state, params) => {
  state.params = params
}

export const setUserInfo = (state, params) => {
  state.user_info = params
}



// WEBPACK FOOTER //
// ./src/store/mutations.js